import { required, Validator, email, phone } from '@/entities/validation';
import { ReminderConfiguration } from './model';

export const validate: Validator<ReminderConfiguration> = configuration => [
  ...email(configuration.notificationEmail, 'notificationEmail'),
  ...phone(configuration.phoneNumber, 'phoneNumber'),
  ...(configuration.notificationSettings.some(settings => settings.data.email)
    ? required(configuration.notificationEmail, 'notificationEmail')
    : []),
  ...(configuration.notificationSettings.some(settings => settings.data.sms)
    ? required(configuration.phoneNumber, 'phoneNumber')
    : []),
];
